<template>
   
    <div> 
        <div class="crumbs" style="margin-left:10px;" hidden="true">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 轮询管理
                </el-breadcrumb-item>
                 <el-breadcrumb-item>执行记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div> 
        <el-card shadow="hover"  class="searchChooseCard" >
                <span class="label-span">
                    <label class="label">配置名称</label>     
                    <el-select v-model.trim="query.code"   placeholder="配置名称" filterable  clearable class="handle-select mr15" > 
                        <el-option value="" label="全部" />
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select> 
                </span>
                
                <el-button type="success" icon="el-icon-search"   class="mr10"  @click="handleSearch">搜索</el-button>
                <el-button type="warning" icon="el-icon-refresh"  class="mr10"   @click="refreshSearch">重置</el-button>
                <el-button type="primary" icon="el-icon-lx-roundadd" class="mr10"   @click="addBind" >添加轮询</el-button> 
                 
               
        </el-card>
        <el-card shadow="hover"  class="containCard" >  
            <el-table :data="tableData" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange" 
            v-loading="loading" element-loading-text="正在保存商品数据" element-loading-spinner="el-icon-loading" >
                <el-table-column prop="taskName"  min-width="100" align="center" label="轮询名称"></el-table-column> 
                <el-table-column prop="code"  min-width="120" align="left" label="配置编码">  </el-table-column>   
                <el-table-column prop="taskType"  min-width="90" align="center" label="轮询类型">
                     <template slot-scope="scope"> 
                        {{scope.row.taskType==1?'定时轮询':'重复轮询'}}
                    </template> 
                </el-table-column>  
                <el-table-column prop="taskType" min-width="210" align="left" label="轮询参数">
                    <template slot-scope="scope"> 
                        <span v-if="scope.row.taskType==1"><i class='el-icon-lx-time'></i> 每天 {{scope.row.taskNum1}}点 {{scope.row.taskNum2}} 分执行</span>
                        <span v-if="scope.row.taskType==2"><i class='el-icon-lx-time'></i> 每 {{scope.row.taskNum2}} 分钟的第 {{scope.row.taskNum1}} 分钟执行</span>
                    </template> 
                </el-table-column>  
                <!-- <el-table-column prop="threadNum" min-width="80" align="center" label="线程数">  </el-table-column>   
                -->
                <el-table-column prop="status"  min-width="90" align="center" label="轮询状态">
                    <template slot-scope="scope"> 
                        <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                    </template> 
                </el-table-column>   
                <el-table-column prop="createTime"  min-width="160" align="center" label="创建时间">
                    <template slot-scope="scope"> 
                        {{scope.row.createTime}}  
                    </template> 
                </el-table-column>    
                <el-table-column label="操作" min-width="180" align="center"  fixed="right">
                    <template slot-scope="scope"> 
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                        <span class='tableOperBtn' @click="handExcute(scope.$index, scope.row)" ><i class='el-icon-video-play'></i> 执行</span>
                        
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 30, 100]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </el-card>
         
        <el-dialog :close-on-click-modal="false" title="添加轮询" :modal-append-to-body='false' :visible.sync="addVisible"  width="380px">
             <el-form ref="form" :model="form1" label-width="80px"> 
                <el-form-item label="配置名称" >
                    <el-select v-model.trim="form1.code"   placeholder="配置名称" style="width:100%" filterable  clearable > 
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select> 
                </el-form-item>
                <el-form-item label="轮询类型" >
                    <el-radio-group  v-model.trim="form1.taskType" >
                        <el-radio-button label="1">定时轮询</el-radio-button> 
                        <el-radio-button label="2">重复轮询</el-radio-button> 
                    </el-radio-group>    
                </el-form-item>
                <el-form-item label="轮询参数" v-if="form1.taskType==1" >
                    每天 <el-input  type="text" placeholder="小时" oninput="value=value.replace(/[^\d]/g,'')"  v-model.trim="form1.taskNum1" style='width:30%'></el-input> 时
                    <el-input  type="text" placeholder="分钟" oninput="value=value.replace(/[^\d]/g,'')" v-model.trim="form1.taskNum2" style='width:30%'></el-input> 分 执行
                </el-form-item> 
                <el-form-item label="轮询参数" v-if="form1.taskType==2" > 
                    每 <el-input  type="text" placeholder="分子" oninput="value=value.replace(/[^\d]/g,'')" v-model.trim="form1.taskNum1" style='width:30%'></el-input> / 
                    <el-input  type="text" placeholder="分母" oninput="value=value.replace(/[^\d]/g,'')" v-model.trim="form1.taskNum2" style='width:30%'></el-input> 分钟执行
                </el-form-item>  
                <!-- <el-form-item label="线程数量" >
                    <el-input  type="text" placeholder="线程数量" oninput="value=value.replace(/[^\d]/g,'')"  v-model.trim="form1.threadNum"></el-input>
                    <p class='tip'>最大线程数不超过当前服务器核心的2倍</p>
                </el-form-item> -->
            </el-form>
             <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="编辑轮询" :modal-append-to-body='false' :visible.sync="editVisible"  width="380px">
             <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="配置名称" >
                    <el-select v-model.trim="form2.code"   placeholder="配置名称" style="width:100%" filterable  clearable > 
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select> 
                </el-form-item>
                <el-form-item label="轮询类型" >
                    <el-radio-group  v-model.trim="form2.taskType" >
                        <el-radio-button label="1">定时轮询</el-radio-button> 
                        <el-radio-button label="2">重复轮询</el-radio-button> 
                    </el-radio-group>    
                </el-form-item>
                <el-form-item label="轮询参数" v-if="form2.taskType==1" >
                    <el-input  type="text" placeholder="小时" oninput="value=value.replace(/[^\d]/g,'')"  v-model.trim="form2.taskNum1" style='width:40%'></el-input> 时
                    <el-input  type="text" placeholder="分钟" oninput="value=value.replace(/[^\d]/g,'')" v-model.trim="form2.taskNum2" style='width:40%'></el-input> 分
                </el-form-item> 
                <el-form-item label="轮询参数" v-if="form2.taskType==2" >
                    <el-input  type="text" placeholder="分子" oninput="value=value.replace(/[^\d]/g,'')" v-model.trim="form2.taskNum1" style='width:42%'></el-input> /
                    <el-input  type="text" placeholder="分母" oninput="value=value.replace(/[^\d]/g,'')" v-model.trim="form2.taskNum2" style='width:42%'></el-input> 分
                </el-form-item>  
                <!-- <el-form-item label="线程数量" >
                    <el-input  type="text" placeholder="线程数量" oninput="value=value.replace(/[^\d]/g,'')"  v-model.trim="form2.threadNum"></el-input>
                    <p class='tip'>最大线程数不超过当前服务器核心的2倍</p>
                </el-form-item> -->
            </el-form>
             <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="轮询参数" :modal-append-to-body='false' :visible.sync="paramVisible"  width="380px">
             <el-form ref="form" :model="form" label-width="80px"> 
                <el-form-item label="轮询参数" >
                    <el-input  type="textarea" rows="5" v-model.trim="form4.param"></el-input>
                    <p class='tip'>填写轮询json参数</p>
                </el-form-item>  
            </el-form>
             <span slot="footer" class="dialog-footer">
                <el-button @click="paramVisible = false">取 消</el-button>
                <el-button type="primary" @click="invokeTask">立即执行</el-button>
            </span>
        </el-dialog>
        
    </div>
</template>

<script>
import {fetchData,saveForm,changeForm, handDelete,changeStatus,handExcute} from '../../../api/taskList';
import {fetchSelect} from '../../../api/taskConfig';
 
export default {

    data() {
        return {    
            taskUse:false,
            mid:'',
            secret:'',
            loading:false,
            stationId:'', 
            shopCode:'',
            loginName:'', 
            shopLink:'', 
            select:{option:''},
            query: { 
                pageIndex: 1,
                pageSize: 10, 
            }, 
            tableData: [],
            tableData2:[],
            multipleSelection: [],
            delList: [],  
            editVisible:false,
            addVisible:false,
            paramVisible:false,
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {  
                taskType:'2',
                taskNum1:'1',
                taskNum2:'2',
                threadNum:'1',
            },
            form2:{},
            form4:{
                param:'',
                apiUrl:'',
            },
            idx: -1,
            id: -1
        };
    },
    created() {
        this.getSelect();
    }, 
    //页面加载方法
    mounted: function () {  
        //查询列表
        this.getData();  
        
    },

    methods: {  
         // q启用、禁用--改变状态
        handleStatus(index, row) {  
            var tips ; 
            if(row.status=='0'){ 
                row.status='1';
                tips = "关闭"; 
            }else{ 
                row.status = '0';
                tips = "开启"; 
            }
            // 二次确认删除
            this.$confirm("确认"+tips+"该轮询吗？", '提示', {
                type: 'warning'
            }).then(() => { 
                if(row.status=='0'){ 
                    row.status='1' 
                }else{ 
                    row.status='0' 
                }
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        if(row.status=='0'){ 
                            row.status='1' 
                        }else{ 
                            row.status='0' 
                        }
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {});  
        },
 
        // 触发搜索按钮

        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'code');   
            this.$set(this.query, 'name');   
            this.getData();  
        },   
         //刷新
        refresh(){
            history.go(0); 
        },
        //获取下拉框数据
        getSelect(){ 
            this.select = {}; 
            fetchSelect(this.select).then(res => {   
                if(res.code==200){ 
                    this.select.option = res.data; 
                }
            });
        },

        //查询
        getData(){
            // 获取列表数据  
            this.query.mid = this.mid;
            this.query.shopCode = this.shopCode;
            this.query.stationId = this.stationId; 
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal || 0;  
                }else{
                     this.tableData = null;
                    this.pageTotal = 0;  
                } 
            });
        },
        handExcute(index, row) {   
            this.paramVisible = true;
            this.form4.apiUrl = row.apiUrl; 
        
        },
        invokeTask(){
            this.paramVisible = false;
            let data={};
            if(this.form4.param!=null && this.form4.param!=''){
                data = JSON.parse(this.form4.param);
                data.apiUrl = this.form4.apiUrl;
            }else{
                data.apiUrl = this.form4.apiUrl;
            } 
            
            this.loading = true;
            setTimeout(() => {
                if(this.loading){
                    this.loading = false;
                    this.$message.success("轮询后台执行中");  
                } 
            }, 5000) 
            handExcute(data).then(res => {
                this.loading = false;
                if(res.code=='200'){ 
                    this.$message.success(res.message);   
                }else{ 
                    this.$message.error(res.message); 
                } 
            });
            
        },
        // 删除
        handDelete(index, row) {   
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功');  
                        this.getData();
                    }else{ 
                        this.$message.error(res.message); 
                    } 
                });
            }) 
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val; 
        },
        //批量删除
        delMore() {
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要删除的日志");
                return;
            } 
            let ids = ''; 
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                ids += this.multipleSelection[i].id + ','; 
            } 
            this.form.id = ids.substr(0,ids.length-1);  
            this.form.shopCode = this.shopCode;
            this.form.stationId = this.stationId;  
            handDeleteMore(this.form).then(res => {
                if(res.code=='200'){ 
                    this.changeFalse(); 
                    this.getData();
                    this.$message.success(res.message);  
                }else{
                    this.$message.error(res.message); 
                }
            }); 
        },

         
        addBind(){
            this.addVisible = true;
        },
        //保存新增
        saveForm() {    
            if( !this.form1.code ){
                this.$message.error("请选择配置名称");
                return;
            }   
            if( !this.form1.taskNum1 ||  !this.form1.taskNum2  ){
                this.$message.error("请填写轮询参数");
                return;
            } 
            if(this.form1.taskType==1 && this.form1.taskNum1>23){
                this.$message.error("定时轮询不超过23时");
                return;
            } 
            if(this.form1.taskType==1 && this.form1.taskNum2>60){
                this.$message.error("定时轮询不超过60分钟");
                return;
            } 
            if(this.form1.taskType==2 && this.form1.taskNum2==0){
                this.$message.error("重复轮询分母必须大于0");
                return;
            }  
            if(this.form1.taskType==2 && 60 % parseInt(this.form1.taskNum2)!=0){
                this.$message.error("重复轮询分母必须能被60整除");
                return;
            }  
            if(this.form1.taskType==2 && parseInt(this.form1.taskNum1) >= parseInt(this.form1.taskNum2)){
                this.$message.error("重复轮询分子必须小于分母");
                return;
            }  
            this.addVisible = false; 
            saveForm(this.form1).then(res => { 
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                } 
            });
        }, 
        // 编辑操作
        handleEdit(index, row) {       
            this.editVisible = true;
            this.form2 = row; 
        },
        saveEdit() {   
            if( !this.form2.code ){
                this.$message.error("请选择配置名称");
                return;
            }   
          
            if(this.form2.taskType==1 && this.form2.taskNum1>23){
                this.$message.error("定时轮询不超过23时");
                return;
            } 
            if(this.form2.taskType==1 && this.form2.taskNum2>60){
                this.$message.error("定时轮询不超过60分钟");
                return;
            } 
            if(this.form2.taskType==2 && this.form2.taskNum2==0){
                this.$message.error("重复轮询分母必须大于0");
                return;
            }  
            if(this.form2.taskType==2 && 60 % parseInt(this.form2.taskNum2)!=0){
                this.$message.error("重复轮询分母必须能被60整除");
                return;
            }  
            if(this.form2.taskType==2 && parseInt(this.form2.taskNum1) >= parseInt(this.form2.taskNum2)){
                this.$message.error("重复轮询分子必须小于分母");
                return;
            }  
          
            this.editVisible = false;
            changeForm(this.form2).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.editVisible = true; 
                    this.$message.error(res.message); 
                }
            });
        },
        //复制链接
        copyLink(index,row){ 
            var inputElement =  document.getElementById("copyLink");  
            inputElement.value=this.shopLink+"&af="+row.id;
            inputElement.select();
            // 执行浏览器复制命令
            document.execCommand("Copy");
            //提示已复制
            this.$message.success("已复制成功，快去分享吧");
           
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData(this.query);
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData(this.query);
        }
    }
};
</script>

<style>
.ql-container{
    min-height:250px; 
  }
.ql-editor{
	height: 250px;
}
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 120px;
    display: inline-block;
}

.handle-input {
    width: 180px;
    display: inline-block;
} 
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
